import { isArray } from 'lodash';
import { ReactNode, useMemo } from 'react';
import { usePatientContext } from '../../../../contexts/PatientInfoContext/PatientInfoContext';
import {
  MeasurementResponse,
  MeasurementResultTypeEnum,
  PatientControlLevel,
  useMeasurementResultList
} from '../../../../uc-api-sdk';
import { FetchComponent, FetchComponentStyleProps, Info } from '../../../../uiComponent/FetchComponent/FetchComponent';
import { VitalFetchProps } from '../../type';

export interface VitalFetchContainerProps extends VitalFetchProps {
  type: MeasurementResultTypeEnum | MeasurementResultTypeEnum[];
  needStats: boolean;
  fetchComponentStyleProps?: FetchComponentStyleProps;
  children: (
    data: MeasurementResponse | undefined,
    info: Info,
    memberId?: string,
    controlLevel?: PatientControlLevel,
  ) => ReactNode;
}

export const VitalFetchContainer = ({
  memberId,
  fromDate,
  toDate,
  type,
  needStats,
  fetchComponentStyleProps,
  children,
}: VitalFetchContainerProps) => {
  const { info } = usePatientContext();
  const { controlLevelService } = info || {};

  const typeList = useMemo(() => {
    if (isArray(type)) {
      return type;
    }
    return [type];
  }, [type]);

  const measurementResult = useMeasurementResultList({
    options: { sendOnMount: true },
    params: {
      searchRequest: {
        filter: {
          memberId,
          dateRange: {
            gte: fromDate.toISOString(),
            lte: toDate.toISOString(),
          },
          needStats,
          needDataInVisits: true,
          typeList,
        },
        pageInfo: {
          pagination: false,
        },
      },
    },
  });

  return (
    <FetchComponent
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(fetchComponentStyleProps || {})}
      info={measurementResult}
      showOnRefetch
      alwaysShowChildren
    >
      {(_, info) => children(
        info.data?.data ?? undefined,
        info,
        undefined,
        controlLevelService?.getControlLevelInfo(),
      )}
    </FetchComponent>
  );
};
